import { useAnalytics } from "~/components/Analytics";
import { BuildHtml } from "~/components/BuildHtml";
import {
  ContentItemWithImage,
  ContentItemWithImageProps,
} from "~/components/ContentItemWithImage";
import { Headline } from "~/ui-library";

export type ReportLibraryFeaturedProps = {
  featuredPost: ContentItemWithImageProps;
  featuredDescription: string | null | undefined;
  title?: string | null;
};

export const ReportLibraryFeatured = ({
  featuredDescription,
  featuredPost,
  title,
}: ReportLibraryFeaturedProps) => {
  const { analyticsEnhancedTrack } = useAnalytics();

  return (
    <div className="w-full md:max-w-[480px]">
      {!!title && (
        <Headline as="h2" blockCase level={6} className="mb-m text-gray-900">
          {title}
        </Headline>
      )}
      <ContentItemWithImage
        {...featuredPost}
        containerClassName="mb-s"
        imagePosition="top"
        asHero
        hasResponsiveHeadline={false}
        onHeadlineClick={() =>
          analyticsEnhancedTrack("Featured Report Clicked", {
            reportName: featuredPost.headline,
            target: "headline",
          })
        }
        onKickerClick={() =>
          analyticsEnhancedTrack("Featured Report Clicked", {
            reportName: featuredPost.headline,
            target: "kicker",
          })
        }
      />
      <BuildHtml html={featuredDescription} />
    </div>
  );
};
